import { useStaticQuery, graphql } from "gatsby";

const sessionsQuery = graphql`
  query {
    allYoutubeVideo {
      edges {
        node {
          id
          title
          description
          videoId
          publishedAt
          privacyStatus
          thumbnail {
            url
            width
            height
          }
        }
      }
    }
  }
`;

export const useSessions = () => {
  const data = useStaticQuery(sessionsQuery);
  return data.allYoutubeVideo.edges || [];
};
